// src/config/apiConfig.js

export const BASE_URL = "https://rentastictoys.com/rentastic_backend/api/client";
export const UPLOAD_URL = "https://rentastictoys.com/rentastic_backend/uploads";
export const G_LOGIN_URL = "https://rentastictoys.com/rentastic_backend/api/google-login";
export const PAYMENT_URL = "https://rentastictoys.com/rentastic_backend";


// export const BASE_URL = "http://localhost/rentastic2/api/client";
// export const UPLOAD_URL = "http://localhost/rentastic2/uploads";
// export const G_LOGIN_URL = "http://localhost/rentastic2/api/google-login";
// export const PAYMENT_URL = "http://localhost/rentastic2";